<script setup>
import Icon from 'next/icon/Icon.vue';

defineProps({
  collapsible: {
    type: Boolean,
    default: false,
  },
  isExpanded: {
    type: Boolean,
    default: true,
  },
  label: {
    type: String,
    default: '',
  },
  icon: {
    type: [Object, String],
    default: '',
  },
  sortOptions: {
    type: Array,
    default: () => [],
  },
  activeSort: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['toggle', 'update-sort']);
</script>

<template>
  <div class="relative min-w-0" :class="{ 'ms-5': collapsible }">
    <component
      :is="collapsible ? 'button' : 'div'"
      :type="collapsible ? 'button' : undefined"
      :aria-expanded="collapsible ? isExpanded : undefined"
      :title="label"
      class="relative flex h-8 w-full min-w-0 items-center justify-between gap-2 rounded-full px-2 py-1.5 text-n-slate-9 select-none"
      :class="{
        'pointer-events-none': !collapsible,
        'cursor-pointer hover:bg-n-alpha-2': collapsible,
        'pe-8': collapsible,
        'pe-2': !collapsible,
      }"
      @click.stop="collapsible ? emit('toggle') : undefined"
    >
      <div class="inline-flex min-w-0 items-center gap-2">
        <Icon v-if="icon" :icon="icon" class="size-4 flex-shrink-0" />
        <span
          class="flex-grow truncate text-start text-[11px] font-semibold uppercase tracking-[0.04em] leading-5"
        >
          {{ label }}
        </span>
      </div>
    </component>
    <div
      v-if="collapsible"
      class="absolute end-2 top-1/2 flex -translate-y-1/2 items-center gap-1"
    >
      <button
        type="button"
        class="flex size-6 flex-shrink-0 items-center justify-center rounded-md text-n-slate-10 hover:bg-n-alpha-2 focus-visible:bg-n-alpha-2 focus-visible:outline-none"
        :aria-expanded="isExpanded"
        :aria-label="label"
        @click.stop="emit('toggle')"
      >
        <span
          class="size-3 flex-shrink-0 text-n-slate-9"
          :class="isExpanded ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'"
        />
      </button>
    </div>
  </div>
</template>
